import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import 'hammerjs';
import { PagesModule } from './main/content/pages/pages.module';
import { SharedModule } from './core/modules/shared.module';
import { AppComponent } from './app.component';
import { FuseMainModule } from './main/main.module';
import { FuseSplashScreenService } from './core/services/splash-screen.service';
import { FuseConfigService } from './core/services/config.service';
import { FuseNavigationService } from './core/components/navigation/navigation.service';
import { FuseSampleModule } from './main/content/sample/sample.module';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularFireModule } from 'angularfire2';
import * as firebase from 'firebase';
import { AngularFireDatabase } from "angularfire2/database-deprecated";
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { SetProductModule } from './main/content/set-product/set-product.module';
import { BrandListModule } from './main/content/brand-list/brand-list.module';
import { ProductListModule } from './main/content/product-list/product-list.module';
import { CategoryListModule } from './main/content/category-list/category-list.module';
import { HashtagsListModule } from './main/content/hashtags-list/hashtags-list.module';
import { UserComplaintsModule } from './main/content/user-complaints/user-complaints.module';
import { SuggestionsModule } from './main/content/suggestions/suggestions.module';
import { ComplaintsModule } from './main/content/complaints/complaints.module';
import { UserlistModule } from './main/content/userlist/userlist.module';
import { UserlistPhotoModule } from './main/content/userlist-photo/userlist-photo.module';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { ComplaintsListModule } from './main/content/user-complaints/complaints-list/complaints-list.module';
import { CreateAdminModule } from './main/content/create-admin/create-admin.module';
import { AddToBlaclistModule } from './main/content/add-to-blaclist/add-to-blaclist.module';
import { UsersModule } from './main/content/users/users.module';
import { environment } from '../environments/environment';
import { ContactInfosModule } from './main/content/contact-infos/contact-infos.module';
import { CorporateSupportModule } from './main/content/corporate-support/corporate-support.module';
import { CreateCorporateUserModule } from './main/content/create-corporate-user/create-corporate-user.module';
import { SendMessageModule } from './main/content/send-message/send-message.module';
import { config } from '../environments/firebase.config'
import { CorporateLeadsModule } from './main/content/corporate-leads/corporate-leads.module';
import { RankingModule } from './main/content/ranking/ranking.module';
import { SectorRankingModule } from './main/content/sector-ranking/sector-ranking.module';
import { ApiService } from './core/services/api.service';
import { AngularFirestoreModule, AngularFirestore } from 'angularfire2/firestore';
import { AddtokeywordsModule } from './main/content/addtokeywords/addtokeywords.module';
import { AddToBlackPhotoModule } from './main/content/addtoblackphoto/addtoblackphoto.module';
import { AddtosubkeywordModule } from './main/content/addtosubkeyword/addtosubkeyword.module';
import { KeywordListModule } from './main/content/keyword-list/keyword-list.module';
import { BlogModule } from './main/content/blog/blog.module';
import { RichTextEditorAllModule } from '@syncfusion/ej2-angular-richtexteditor';
import { BlogCategoryModule } from './main/content/blog-category/blog-category.module';
import { BlogListModule } from './main/content/blog-list/blog-list.module';
import { BlogCategoryListModule } from './main/content/blog-categoryList/blog-categoryList.module';


const firebaseConfig = environment.development ? config.development : config.production;
firebase.initializeApp(firebaseConfig);
const appRoutes: Routes = [
    {
        path: '**',
        redirectTo: 'dashboard'
    },
    {
        path: 'set/:type',
        loadChildren: './main/content/set-product/set-product.module#SetProductModule'
    },
    {
        path: 'brandlist',
        loadChildren: './main/content/brand-list/brand-list.module#BrandListModule'
    },
    {
        path: 'productlist',
        loadChildren: './main/content/product-list/product-list.module#ProductListModule'
    },
    {
        path: 'categorylist',
        loadChildren: './main/content/category-list/category-list.module#CategoryListModule'
    },
    {
        path: 'hashtagslist',
        loadChildren: './main/content/hashtags-list/hashtags-list.module#HashtagsListModule'
    },
    {
        path: 'addtokeywords',
        loadChildren: './main/content/addtokeywords/addtokeywords.module#AddtokeywordsModule'
    },
    {
        path: 'addtosubkeyword',
        loadChildren: './main/content/addtosubkeyword/addtosubkeyword.module#AddtosubkeywordModule'
    },
    {
        path: 'complaints',
        loadChildren: './main/content/complaints/complaints.module#ComplaintsModule'
    },
    {
        path: 'user-list',
        loadChildren: './main/content/userlist/userlist.module#UserlistModule'
    },
    {
        path: 'userlist-photo',
        loadChildren: './main/content/userlist-photo/userlist-photo.module#UserlistPhotoModule'

    },
    {
        path: 'suggestions',
        loadChildren: './main/content/suggestions/suggestions.module#SuggestionsModule'
    },
    {
        path: 'user-complaints',
        loadChildren: './main/content/user-complaints/user-complaints.module#UserComplaintsModule'
    },
    {
        path: 'complaints-list',
        loadChildren: './main/content/user-complaints/complaints-list/complaints-list.module#ComplaintsListModule'
    },
    {
        path: 'create-admin',
        loadChildren: './main/content/create-admin/create-admin.module#CreateAdminModule'
    },
    {
        path: 'users',
        loadChildren: './main/content/users/users.module#UsersModule'
    },
    {
        path: 'blog',
        loadChildren: './main/content/blog/blog.module#BlogModule'
    },
    {
        path: 'blog-category',
        loadChildren: './main/content/blog-category/blog-category.module#BlogCategoryModule'
    },
    {
        path: 'blog-list',
        loadChildren: './main/content/blog-list/blog-list.module#BlogListModule'
    },
    {
        path: 'blog-categorylist',
        loadChildren: './main/content/blog-categoryList/blog-categoryList.module#BlogCategoryListModule'
    },

    {
        path: 'addtoblacklist',
        loadChildren: './main/content/add-to-blaclist/add-to-blaclist.module#AddToBlaclistModule'
    },
    {
        path: 'addtoblackphoto',
        loadChildren: './main/content/addtoblackphoto/addtoblackphoto.module#AddToBlackPhotoModule'
    },
    {
        path: 'contact-infos',
        loadChildren: './main/content/contact-infos/contact-infos.module#ContactInfosModule'
    },
    {
        path: 'keyword-list',
        loadChildren: './main/content/keyword-list/keyword-list.module#KeywordListModule'
    },
    {
        path: 'corporate-support',
        loadChildren: './main/content/corporate-support/corporate-support.module#CorporateSupportModule'
    },
    {
        path: 'create-corporate-user',
        loadChildren: './main/content/create-corporate-user/create-corporate-user.module#CreateCorporateUserModule'
    },
    {
        path: 'send-message',
        loadChildren: './main/content/send-message/send-message.module#SendMessageModule'
    },
    {
        path: 'corporate-leads',
        loadChildren: './main/content/corporate-leads/corporate-leads.module#CorporateLeadsModule'
    },
    {
        path: 'ranking',
        loadChildren: './main/content/ranking/ranking.module#RankingModule'
    },
    {
        path: 'sector-ranking',
        loadChildren: './main/content/sector-ranking/sector-ranking.module#SectorRankingModule'
    }
];

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        HttpModule,
        HttpClientModule,
        ProductListModule,
        SendMessageModule,
        BrowserAnimationsModule,
        UserlistModule,
        UserlistPhotoModule,
        HashtagsListModule,
        RouterModule.forRoot(appRoutes),
        AngularFireModule.initializeApp(firebaseConfig),
        SharedModule,
        TranslateModule.forRoot(),
        FuseMainModule,
        CreateCorporateUserModule,
        CorporateSupportModule,
        FormsModule,
        AngularFontAwesomeModule,
        BlogCategoryListModule,
        ComplaintsListModule,
        CreateAdminModule,
        BrandListModule,
        UsersModule,
        BlogListModule,
        SuggestionsModule,
        AddToBlaclistModule,
        BlogModule,
        BlogCategoryModule,
        AddToBlackPhotoModule,
        AddtokeywordsModule,
        AddtosubkeywordModule,
        CategoryListModule,
        AngularFirestoreModule,
        UserComplaintsModule,
        ComplaintsModule,
        ReactiveFormsModule,
        FuseSampleModule,
        ContactInfosModule,
        SetProductModule,
        CorporateLeadsModule,
        SectorRankingModule,
        KeywordListModule,
        RankingModule,
        AngularFireDatabaseModule,
        PagesModule,
        RichTextEditorAllModule
    ],
    providers: [
        FuseSplashScreenService,
        FuseConfigService,
        FuseNavigationService,
        AngularFireDatabase,
        AngularFirestore,
        ApiService
    ],
    bootstrap: [
        AppComponent
    ]
})
export class AppModule {
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/app.module.ts